import { render, staticRenderFns } from "./CoinSettings.vue?vue&type=template&id=bd451500&scoped=true&"
import script from "./CoinSettings.vue?vue&type=script&lang=ts&"
export * from "./CoinSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CoinSettings.vue?vue&type=style&index=0&id=bd451500&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd451500",
  null
  
)

export default component.exports